import React, { Component } from 'react';
import './TrendIcon.css';
import TrendUpIcon from './../../img/icon/TrendUp.png';
import TrendStableIcon from './../../img/icon/TrendStable.png';
import TrendDownIcon from './../../img/icon/TrendDown.png';

export default class TrendIcon extends Component<any, any> {
  constructor(props:any) {
    super(props);
    this.state = {
    }
  }
  componentDidMount() {
  }

  componentWillReceiveProps(nextProps: any) {
    
  }

  renderIcon() {
    switch(this.props.direction) {
      case '1': return <img src={TrendUpIcon} alt=''/>;
      case '-1': return <img src={TrendDownIcon} alt=''/>;
      default: return <img src={TrendStableIcon} alt=''/>;
    }
  }

  render() {
    return (
      <div className="TrendIcon">
        {this.renderIcon()}
      </div>
    );
  }
}
